export const BackDropTypes = {
  SET_SHOW: '@backdrop/SET_SHOW',
}
